module.exports = __webpack_public_path__ + "img/6-3.a33a4ffa.jpg";